import { useState, useEffect } from "react";
import { loadMaterialList } from "../services/materialCategory";
import { loadRequestIndentlist } from "../services/requestIndentService";

const useRequestIndentList = (Mode) => {
    const [requestIndentList, setRequestIndentList] = useState([]);
    const [selectRequestIndent, setSelectedRequestIndent] = useState(null);
    const [selectRequestIndentID, setSelectedRequestIndentID] = useState(null);
    const [isRequestIndentDataLoaded, setIsRequestIndentDataLoaded] = useState(false);

    // Fetch department data
    const fetchRequestIndent = async (selectedID = null) => {
        const para = { p_company_id: localStorage.getItem("companyid"), p_plant_id: 1, p_select_status: Mode };

        try {
            const data = await loadRequestIndentlist(para);
            if (data && data.length > 0) {
                setRequestIndentList(data);                    
                setIsRequestIndentDataLoaded(true);
            }
            else{
                setRequestIndentList([]);                    
                setIsRequestIndentDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

     const fetchRequestAllIndent = async (selectedID = null) => {
        const para = { p_company_id: localStorage.getItem("companyid"), p_plant_id: 1, p_select_status: 'request indent' };

        try {
            const data = await loadRequestIndentlist(para);
            if (data && data.length > 0) {
                setRequestIndentList(data);                    
                setIsRequestIndentDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isRequestIndentDataLoaded) {
            fetchRequestIndent();
        }
    }, [isRequestIndentDataLoaded]);

    // Function to load department based on selected ID
    const loadRequestIndentByID = async (selectedID) => {
        await fetchRequestIndent(selectedID);
    };

     const loadRequestIndentByAllID = async (selectedID) => {
        await fetchRequestAllIndent(selectedID);
    };
    return {
        requestIndentList,
        setRequestIndentList,
        selectRequestIndent,
        selectRequestIndentID,
        loadRequestIndentByID,
        loadRequestIndentByAllID,
        
    };
};

export default useRequestIndentList;
